import React, { useCallback, useMemo } from 'react';

import { CollectionFolder } from 'editor/src/store/collections/types';
import { MediaImage } from 'editor/src/store/design/types';
import {
  AdvancedPersonalisationElementData,
  getCollectionAssetLabel,
} from 'editor/src/store/plugins/utils/advPersoUtils';

import PersonalisationDropDown from 'editor/src/component/PersonalizationContent/PersonalizationElements/PersonalisationDropDown';

interface Props {
  image: MediaImage;
  folder: CollectionFolder;
  collectionInfo: AdvancedPersonalisationElementData;
  selectAsset: (assetId: string, url: string) => void;
}

function PersonalisationCollectionDropdown({ image, folder, collectionInfo, selectAsset }: Props) {
  const activeOptionIndex = folder.assets.findIndex((asset) => asset.id === image.imageId);
  const options = useMemo(
    () =>
      folder.assets.map((asset) => ({
        imageUrl: asset.url,
        label: getCollectionAssetLabel(collectionInfo, asset),
      })),
    [folder.assets, collectionInfo],
  );

  const onSelect = useCallback(
    (index: number) => {
      const asset = folder.assets[index];
      selectAsset(asset.id, asset.url);
    },
    [folder.assets],
  );

  return (
    <PersonalisationDropDown
      className="cy-collection-dropdown"
      options={options}
      activeOptionIndex={activeOptionIndex}
      selectOption={onSelect}
    />
  );
}
export default React.memo(PersonalisationCollectionDropdown);
